import { botModeDefinition } from './BotMode';
import { endlessModeDefinition } from './EndlessMode';
import { singlePlayerModeDefinition } from './SinglePlayerMode';
import { versusModeDefinition } from './VersusMode';
import { hasGameMode, registerGameMode } from './registry';

/**
 * Every mode the build knows about. New modes get added here and nowhere else.
 * Kept apart from `registry.ts` so importing the registry does not drag in
 * every mode implementation.
 */
export function registerBuiltInGameModes(): void {
  if (!hasGameMode(botModeDefinition.id)) registerGameMode(botModeDefinition);
  if (!hasGameMode(endlessModeDefinition.id)) registerGameMode(endlessModeDefinition);
  if (!hasGameMode(singlePlayerModeDefinition.id)) registerGameMode(singlePlayerModeDefinition);
  if (!hasGameMode(versusModeDefinition.id)) registerGameMode(versusModeDefinition);
}
